import React, {useEffect} from "react";

import styles from "./../SearchItem.module.scss";

import stylesGlobal from "../../../../ListItem.module.scss";

import cn from "classnames";

const GoogleSearchItem = ( { item, lineNumber, active, setLineLinks} ) => {

    useEffect(() => {
        if (!isNaN(lineNumber)) {
            setLineLinks(links => ({
                ...links,
                [lineNumber]: item.link,
            }))
        }
    }, [lineNumber, item?.link]);

    return (
        <li className={cn(styles.item, {[stylesGlobal.activeLine]: active})}>
            <div className={styles.info}>
                <a href={item.link} className={styles.link}>{item.title}</a>
                <div>
                    {item.pagemap?.listitem?.length > 1 &&
                        <div className={styles.breadcrumbs}>
                            {item.pagemap.listitem.slice(0, -1).map(i => i.name).join(' > ')}
                        </div>
                    }
                    <p className={styles.description}>{item.snippet}</p>
                </div>
                <a href={item.link} className={styles.arrowLink}>
                    <svg className={styles.arrow}>
                        <use href="/webpack/dist/sprite.svg#icon-chevron-right"></use>
                    </svg>
                </a>
            </div>

        </li>
    )
};

export default GoogleSearchItem;
